import { getLogger } from '@ravago/shared/logging/client';
import { TypeHeader, TypeHeaderFields } from '@ravago/shared/page-data/models/contentful-generated';
import { NormalizedCollection, NormalizedHeader } from '@ravago/shared/page-data/models/contentful-mapped';
import { ContentfulUtils } from '@ravago/shared/page-data/utils/contentful';
import { DataMapperUtils } from '@ravago/shared/page-data/utils/data-mapper';
import { LogMessageUtils } from '@ravago/shared/page-data/utils/logging';
import { validateAndFilterHeaderEntries, validateHeaderEntry } from '@ravago/shared/page-data/validators';

import { ContentfulClientApi } from 'contentful';

export class MenuUtils {
  static async getMenuList(contentfulClientApi: ContentfulClientApi, locale: string): Promise<NormalizedCollection<NormalizedHeader>> {
    try {
      const entries = await contentfulClientApi.getEntries<TypeHeaderFields>({ content_type: 'header', locale, limit: 1000, include: 10 });

      if (!entries.total) return ContentfulUtils.getDefaultCollection();

      const validEntries = validateAndFilterHeaderEntries(entries.items);

      entries.items = validEntries;

      return DataMapperUtils.normalizeContentfulCollection<NormalizedCollection<NormalizedHeader>>(entries, DataMapperUtils.normalizeContentfulHeader);
    } catch (error) {
      getLogger().error(error instanceof Error ? error.message : 'Unknown error occurred.');

      return ContentfulUtils.getDefaultCollection();
    }
  }

  static async getMenuById(contentfulClientApi: ContentfulClientApi, locale: string, menuId: string): Promise<NormalizedHeader | null> {
    try {
      const entries = await contentfulClientApi.getEntries<TypeHeaderFields>({ content_type: 'header', locale, limit: 1, include: 10, 'sys.id': menuId });

      if (!entries.total) return null;

      const validationResult = validateHeaderEntry(entries.items?.[0]);

      if (!validationResult.success) {
        console.error(LogMessageUtils.validationFailed('HEADER'), validationResult.error.message);
        return null;
      }

      return DataMapperUtils.normalizeContentfulHeader(validationResult.data as unknown as TypeHeader);
    } catch (error) {
      getLogger().error(error instanceof Error ? error.message : 'Unknown error occurred.');

      return null;
    }
  }
}
